'use strict';

import React, {useState} from 'react';

import {FormattedMessage, injectIntl} from 'react-intl';
import OTButton from '../../../components/tag/OTButton';
import NotificationWithIcon from '../../../components/NotificationWithIcon';
import { getTime } from '../../../utils/TimeUtils';
import { getDepartmentDisplay } from '../../../utils/TimelineUtils';
import Span from "../../../components/tag/Span";
import OTButtonGroup from "../../../components/tag/OTButtonGroup";
import Urls from '../../../definitions/Urls';

const ReferralNotification = ({
  data,
  setReferralNotified,
  intl
}) => {

  const [disabled, setDisabled] = useState(false)

  const { id, department } = data;

  const departmentDisplay = getDepartmentDisplay(department).toLowerCase();
  const notificationDate = getTime(data.date);
  const date = notificationDate.format('DD.MM.YYYY');
  const time = notificationDate.format('HH.mm');

  const titleMessage = () => {
    return {id: intl.messages[`referral.notification.title.${data.referralState}.${data.referralStateSpecifier}`] ?
        `referral.notification.title.${data.referralState}.${data.referralStateSpecifier}` :
        `referral.notification.title.vastaanotettu`};
  }

  const descriptionMessage = () => {
    return intl.messages[`referral.notification.description.${data.referralState}.${data.referralStateSpecifier}`] ?
        `referral.notification.description.${data.referralState}.${data.referralStateSpecifier}` :
        `referral.notification.description.vastaanotettu`;
  }

  return (
      <NotificationWithIcon
          titleIntl={titleMessage()}
          dateString={notificationDate.format('DD.MM.YYYY')}
          description={
            <>
              <FormattedMessage
                  id={descriptionMessage()}
                  values={{
                    date: date,
                    time: time,
                    department: departmentDisplay,
                    br: <br />,
                    strong: (chunks) => <strong>{chunks}</strong>,
                    span: (chunks) => <span className="department">{chunks}</span>,
                  }}
              >
                {txt => <div className={"ot-notification__referral"}>
                  {txt}
                </div>}
              </FormattedMessage>
              <FormattedMessage
                id={'referral.omakanta'}
                values={{
                  br: <br />,
                  link: <a target={"_blank"} href={Urls.omaKanta}>OmaKanta-palvelussa<i className="icon-external-link"/> </a>
                }}
              />
            </>
          }
          actions={
            <div className="row-fluid">
              <Span len="6" sm-len="12" style={{ marginBottom: '10px' }}>
                <OTButtonGroup fullWidth={true} type="big" collapseOnMobile>
                  <OTButton
                      key="approve"
                      message="OK"
                      onClick={() => {
                        setDisabled(true);
                        setReferralNotified(id)
                      }}
                      disabled={disabled}
                  />
                </OTButtonGroup>
              </Span>
            </div>
          }
      />
  );
}

export default injectIntl(ReferralNotification);
